import React from "react";
import { useParams } from "react-router-dom";
import { buildEmployeeDetailInformationRoute } from "../../routes/AdminRoutes";
import Profile from "../../views/Profile/Profile";
import { useEmployeeProfile } from "../../hooks/employeeProfile";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

export default function EmployeeContainerEditProfile() {
  const { employeeId } = useParams();
  const dispatch = useDispatch();
  const {
    employeeProfile,
    getEmployeeProfile,
    updateEmployeeProfile,
    isLoading
  } = useEmployeeProfile(employeeId);

  const onGoBack = React.useCallback(() => {
    dispatch(push(buildEmployeeDetailInformationRoute(employeeId)));
  }, []);

  const onProfilePictureApply = React.useCallback(
    async (file, successCallback) => {
      await updateEmployeeProfile({ profileImage: file });
      successCallback();
    },
    [updateEmployeeProfile]
  );

  if (!employeeProfile) return <LoadingSpinner />;

  return (
    <React.Fragment>
      <Profile
        onGoBack={onGoBack}
        isAdmin={true}
        fullName={employeeProfile.fullName}
        userId={employeeProfile.firstName}
        firstName={employeeProfile.firstName}
        lastName={employeeProfile.lastName}
        position={employeeProfile?.position?.name}
        location={employeeProfile?.location?.name}
        phone={employeeProfile.phone}
        email={employeeProfile.email}
        hireDate={employeeProfile.hireDate}
        preferredLanguage={employeeProfile.preferredLanguage || "en"}
        profilePicture={employeeProfile.profileImage}
        updating={isLoading}
        onProfilePictureApply={onProfilePictureApply}
        onSave={updateEmployeeProfile}
        onCancel={getEmployeeProfile}
      />
    </React.Fragment>
  );
}
